<template>
  <div class="material-list">
    <template v-if="!!materialList.length">
      <div class="material-content" v-for="item in materialList" :key="item.id">
        <div class="img">
          <img class="thumb" :src="getImgSrc(item)" v-if="item.type !== 19">
          <img class="thumb" src="@/assets/images/public/font.png" v-else>
          <div class="control-buttons">
            <el-button type="info" size="mini" round @click="top(item.id, item.type)">置顶</el-button>
            <el-button type="info" size="mini" round @click="edit(item)">修改</el-button>
            <el-button type="info" size="mini" round @click="del(item.id)">删除</el-button>
            <el-button type="info" size="mini" round @click="view(item)" v-if="item.type === 1 || item.type ===2">查看</el-button>
          </div>
        </div>
        <div class="name">{{ item.name }}</div>
      </div>
    </template>
    <template v-else>
      <div class="empty">暂无数据</div>
    </template>
    <div class="material-content loadMore" @click="loadMore" v-show="count !== materialList.length" style="cursor: pointer;">{{ getLoadMoreContent() }}</div>
    <div class="material-content loadMore" @click="loadMore" v-show="count === materialList.length && !!count">{{ loadAll() }}</div>
    <form-dialog  
      :dialogVisible="editVisible"
      @closeDialog="closeThemeDialog"
      title="参数修改"
    >
      <div class="edit-dialog">
        <el-form :model="editForm" :rules="rules" label-width="80px" ref="form">
          <el-form-item label="参数名称" prop="name">
            <el-input v-model="editForm.name"></el-input>
          </el-form-item>
          <el-form-item label="">
            <div style="padding-left: 20px;">{{ editData.name }}</div>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button size="small" round @click="editVisible = false">取消</el-button>
          <el-button size="small" type="primary" round @click="confirm">确定</el-button>
        </div>
      </div>
    </form-dialog>
    <del-dialog :dialogVisible="delDialogVisible" @closeDialog="delCloseDialog" title="删除素材">
      <div style="text-align: center;">确定要删除素材？</div>
    </del-dialog>
    <preview :previewData="previewData" @previewVisible="previewVisible"></preview>
  </div>
</template>

<script>
import FormDialog from "@/components/basics/FormDialog";
import DelDialog from '@/components/basics/DelDialog';
import Preview from '@/components/basics/Preview'
export default {
  name: "MaterialList",
  props: {
    materialList: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      default: 0
    },
    themeId: {
      type: Number,
      default: 0
    },
    themeType: {
      type: Number,
      default: 2
    }
  },
  data(){
    return {
      editVisible: false,
      editForm:{
        name: ''
      },
      editData:{},
      rules: {
        name: [{ required: true, message: '请输入参数名称', trigger: 'blur' }]
      },
      delDialogVisible: false,
      previewData: {
        visible: false,
        type: "",
        src: ""
      }
    }
  },
  components: {
    FormDialog,
    DelDialog,
    Preview
  },
  methods:{
    top(id,type){
      this.$http.post('/admin/template/stickyPost',{
        id,
        themeId: this.themeId,
        type,
        group_ids: this.$cookies.get('group_ids')
      },() => {
        this.$emit('refresh');
      })
    },
    edit(data){
      this.editData = data;
      this.editForm.name = data.name.slice(0, data.name.lastIndexOf('.'));
      this.editVisible = true;
    },
    del(id){
      this.delId = id;
      this.delDialogVisible = true;
    },
    confirm(){
      this.$refs.form.validate(valid =>{
        if(valid) {
          this.$http.post('/admin/template/editMaterial',{
            id: this.editData.id,
            name: this.editForm.name
          },data => {
            if(data){
              this.$emit('refresh')
            }
            this.editVisible = false;
          })
        }
      })
    },
    delCloseDialog(isConfirm){
      if(isConfirm){
        this.$http.post('/admin/template/delMaterials',{
          ids: this.delId
        },()=>{
          this.$emit('refresh')
        })
      }
      this.delDialogVisible = false;
    },
    view(data){
      this.previewData.visible = true;
      this.previewData.type = data.type.toString();
      this.previewData.src = data.fileurl;
    },
    previewVisible() {
      this.$set(this.previewData, "visible", false);
    },
    getImgSrc(item){
      switch (item.type) {
        case 1:
        case 2:
          return item.ref_thumb_url;
        case 19:
          return '../../../assets/images/public/font.png';
      }
    },
    loadMore(){
      // 当前页码
      const page = Math.ceil(this.materialList.length / 10);
      this.$emit('loadMore', page + 1, this.themeId);
    },
    getLoadMoreContent(){
      switch(this.themeType) {
        case 2:
          return '点击加载更多素材';
        case 3:
          return '点击加载更多字体'
      }
    },
    loadAll() {
      switch(this.themeType) {
        case 2:
          return '已加载全部素材';
        case 3:
          return '已加载全部字体'
      }
    },
    closeThemeDialog(){
      this.editVisible = false;
      this.$refs.form.resetFields();
    }
  }    
}
</script>

<style lang="scss" scoped>
.material-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .material-content {
    width: 240px;
    height: 160px;
    margin: 10px;
    background-color: rgba($color: #909399, $alpha: 0.3);
    .img {
      width: 220px;
      height: 125px;
      margin: 5px auto;
      position: relative;
      .thumb {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .control-buttons {
        position: absolute;
        left: 50%;
        top: 50px;
        transform: translateX(-50%);
        display: none;
      }
      &:hover {
        .control-buttons {
          display: flex;
        }
      }
      
    }
    .name {
      text-align: center;
    }
  }
  .empty {
    height: 30px;
    line-height: 30px;
    padding: 20px 0;
    color: #909399;
  }
  .loadMore {
    text-align: center;
    line-height: 160px;
  }
  .edit-dialog {
    .footer {
      display: flex;
      justify-content: center;
    }
  }
}
</style>